import { useContext } from "react"
import { useEffect } from "react"
import { useState } from "react"
import { api } from "../../../api/api"
import { MenuContext } from "../../../context/MenuContext"
import { Toast } from "../../../utils/Toast"
import "../menu-form.css"


export function CategoryAdditionalModal() {
  const { productId, load, categoryAdditionalEdit, setCategoryAdditionalEdit } = useContext(MenuContext)

  const [state, setState] = useState({
    id: null,
    name: "",
    productId: productId,
    min: 0,
    max: 0,
    active: false,
    useHighestItemPrice: false
  })

  useEffect(() => {
    setState({
      ...state,
      productId: productId
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productId])

  useEffect(() => {
    if (categoryAdditionalEdit.id)
      setState({
        id: categoryAdditionalEdit.id,
        name: categoryAdditionalEdit.name,
        productId: categoryAdditionalEdit.productId,
        min: categoryAdditionalEdit.min,
        max: categoryAdditionalEdit.max,
        active: Boolean(categoryAdditionalEdit.active),
        useHighestItemPrice: Boolean(categoryAdditionalEdit.useHighestItemPrice)
      })
  }, [categoryAdditionalEdit])


  async function created(e) {
    e.preventDefault()

    if (!state.name) {
      return Toast.warning('Campo nome é obrigatório.')
    }

    const response = await api.post("/category/additional", state)
    const { id } = response.data
    setState({
      ...state,
      id
    })
    Toast.success()
    await load()
    clear()
    return id
  }

  async function updated(e) {
    e.preventDefault()

    if (!state.name) {
      return Toast.warning('Campo nome é obrigatório.')
    }

    const response = await api.put("/category/additional/" + state.id, state)
    const { id } = response.data
    setState({
      ...state,
      id
    })
    Toast.success()
    await load()
    clear()
    return id
  }

  function clear() {
    setState({
      id: null,
      name: "",
      productId: productId,
      min: 0,
      max: 0,
      active: false,
      useHighestItemPrice: false
    })
    setCategoryAdditionalEdit({})
  }

  return (
    <>
      <div className="modal fade admin-form-modal menu-entity-modal" id="modalCategoryAdditional" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="categoryAdditionalModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <div><h5 className="modal-title" id="categoryAdditionalModalLabel">{state.id ? 'Editar grupo de adicionais' : 'Novo grupo de adicionais'}</h5><p>Defina as regras de escolha dos complementos</p></div>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => clear()}></button>
            </div>
            <div className="modal-body">
              <form className="menu-modal-grid">
                <div className="menu-modal-full">
                  <label htmlFor="additional-group-name">Nome do grupo</label>
                  <input type="text" value={state.name} onChange={(e) => setState({
                    ...state,
                    name: e.target.value
                  })} id="additional-group-name" />
                  <small>Exemplo: Escolha o molho ou Adicione acompanhamentos.</small>
                </div>
                <div>
                  <label htmlFor="additional-group-min">Quantidade mínima</label>
                  <input type="number" min="0" value={state.min} onChange={(e) => setState({
                    ...state,
                    min: e.target.value
                  })} id="additional-group-min" />
                </div>
                <div>
                  <label htmlFor="additional-group-max">Quantidade máxima</label>
                  <input type="number" min="0" value={state.max} onChange={(e) => setState({
                    ...state,
                    max: e.target.value
                  })} id="additional-group-max" />
                </div>
                <div className="menu-modal-options menu-modal-full">
                  <label className="menu-modal-check" htmlFor="additional-group-active">
                    <input type="checkbox" checked={state.active} onChange={(e) => setState({
                      ...state,
                      active: Boolean(e.target.checked)
                    })} id="additional-group-active" /> Grupo ativo
                  </label>
                  <label className="menu-modal-check" htmlFor="additional-group-highest-price">
                    <input type="checkbox" checked={state.useHighestItemPrice} onChange={(e) => setState({
                      ...state,
                      useHighestItemPrice: Boolean(e.target.checked)
                    })} id="additional-group-highest-price" /> Usar preço do item mais caro
                  </label>
                </div>
              </form>
              <div className="menu-modal-actions"><button type="button" className="admin-primary-button" onClick={state.id ? updated : created}>Salvar grupo</button></div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
